import * as client_hooks from '../../../src/hooks.client.ts';
import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158'),
	() => import('./nodes/159'),
	() => import('./nodes/160'),
	() => import('./nodes/161'),
	() => import('./nodes/162'),
	() => import('./nodes/163'),
	() => import('./nodes/164'),
	() => import('./nodes/165'),
	() => import('./nodes/166'),
	() => import('./nodes/167')
];

export const server_loads = [0,2,3,4,5];

export const dictionary = {
		"/": [~6],
		"/adjustments/[id]": [7],
		"/admin": [~8],
		"/admin/announcements": [9],
		"/admin/queues": [~10],
		"/admin/queues/direct": [~11],
		"/cart/review": [~12],
		"/design-showcase": [13],
		"/docs": [~14,[2]],
		"/docs/customers": [15,[2]],
		"/docs/customers/accounts": [16,[2]],
		"/docs/customers/payments": [17,[2]],
		"/docs/customers/pickup": [18,[2]],
		"/docs/customers/shopping": [19,[2]],
		"/docs/customers/support": [20,[2]],
		"/docs/getting-started": [21,[2]],
		"/docs/getting-started/first-week": [22,[2]],
		"/docs/getting-started/market-setup": [23,[2]],
		"/docs/getting-started/overview": [24,[2]],
		"/docs/getting-started/quick-start": [25,[2]],
		"/docs/growers": [26,[2]],
		"/docs/growers/best-practices": [27,[2]],
		"/docs/growers/getting-started": [28,[2]],
		"/docs/growers/harvest": [29,[2]],
		"/docs/growers/photos": [30,[2]],
		"/docs/growers/pricing": [31,[2]],
		"/docs/growers/products": [32,[2]],
		"/docs/markdown-guide": [~33,[2]],
		"/docs/market": [34,[2]],
		"/docs/market/crisis-management": [35,[2]],
		"/docs/market/email-templates": [36,[2]],
		"/docs/market/financial-management": [37,[2]],
		"/docs/market/marketing": [38,[2]],
		"/docs/market/multi-market": [39,[2]],
		"/docs/market/ordering-cycles": [40,[2]],
		"/docs/market/payments": [41,[2]],
		"/docs/market/pickup-locations": [42,[2]],
		"/docs/market/reports": [43,[2]],
		"/docs/market/seasonal-planning": [44,[2]],
		"/docs/market/settings": [45,[2]],
		"/docs/market/themes": [46,[2]],
		"/docs/market/volunteer-management": [47,[2]],
		"/docs/support": [48,[2]],
		"/docs/support/community": [49,[2]],
		"/docs/support/contact": [50,[2]],
		"/docs/support/faq": [51,[2]],
		"/docs/support/training": [52,[2]],
		"/docs/support/whats-new": [53,[2]],
		"/docs/technical": [54,[2]],
		"/docs/technical/api": [55,[2]],
		"/docs/technical/data-management": [56,[2]],
		"/docs/technical/integrations": [57,[2]],
		"/docs/technical/security": [58,[2]],
		"/docs/technical/troubleshooting": [59,[2]],
		"/docs/technical/webhooks": [60,[2]],
		"/docs/theming": [61,[2]],
		"/documents": [~62],
		"/faq": [~63],
		"/faq/marketing": [~64],
		"/features": [65],
		"/forgot-password": [66],
		"/growers": [~67],
		"/growers/map": [~70],
		"/growers/new": [~71],
		"/growers/[id]": [~68],
		"/growers/[id]/edit": [~69],
		"/health": [72],
		"/legacy/admin": [~73],
		"/legacy/faq": [~74],
		"/legacy/growers": [~75],
		"/legacy/growers/map": [~78],
		"/legacy/growers/new": [~79],
		"/legacy/growers/[id]": [~76],
		"/legacy/growers/[id]/edit": [~77],
		"/legacy/market": [~80],
		"/legacy/photos/new": [~82],
		"/legacy/photos/[id]": [~81],
		"/legacy/recipes": [~83,[3]],
		"/legacy/recipes/new": [~86,[3]],
		"/legacy/recipes/[id]": [~84,[3]],
		"/legacy/recipes/[id]/edit": [~85,[3]],
		"/legacy/weblog": [~87],
		"/legacy/weblog/view/[id]": [~89],
		"/legacy/weblog/[id]": [~88],
		"/legacy/welcome": [~90],
		"/legal": [~91],
		"/legal/[page]": [~92],
		"/locations": [~93],
		"/locations/map": [~94],
		"/markets": [~96],
		"/markets/edit": [~97],
		"/markets/list": [98],
		"/markets/map": [~99],
		"/markets/new": [~100],
		"/markets/new/success": [~101],
		"/market": [~95],
		"/modern/faq": [~102],
		"/modern/growers": [~103],
		"/modern/growers/map": [~106],
		"/modern/growers/new": [~107],
		"/modern/growers/[id]": [~104],
		"/modern/growers/[id]/edit": [~105],
		"/modern/market": [~108],
		"/modern/photos/new": [~110],
		"/modern/photos/[id]": [~109],
		"/modern/recipes": [~111],
		"/modern/recipes/new": [~114],
		"/modern/recipes/[id]": [~112],
		"/modern/recipes/[id]/edit": [~113],
		"/modern/weblog": [~115],
		"/modern/weblog/view/[id]": [~117],
		"/modern/weblog/[id]": [~116],
		"/modern/welcome": [~118],
		"/order_items/chargebacks": [~119],
		"/order_items/refunds": [~120],
		"/orders": [~121],
		"/orders/by-location": [~124],
		"/orders/checkin": [~125],
		"/orders/checkout": [~126],
		"/orders/harvest_by_location/[id]": [~128],
		"/orders/harvest_history/[growerId]": [~129],
		"/orders/harvest/[id]": [~127],
		"/orders/list": [~130],
		"/orders/payment_summary": [~131],
		"/orders/unclaimed": [~132],
		"/orders/[id]": [122],
		"/orders/[id]/edit": [~123],
		"/photos/new": [~134],
		"/photos/[id]": [~133],
		"/pricing": [135],
		"/products": [~136],
		"/recipes": [~137,[4]],
		"/recipes/new": [~140,[4]],
		"/recipes/[id]": [~138,[4]],
		"/recipes/[id]/edit": [~139,[4]],
		"/reset-password/[token]": [~141],
		"/showcase": [142,[5]],
		"/showcase/accessibility": [143,[5]],
		"/showcase/animations": [144,[5]],
		"/showcase/components": [145,[5]],
		"/showcase/components/data": [146,[5]],
		"/showcase/components/feedback": [147,[5]],
		"/showcase/components/forms": [148,[5]],
		"/showcase/components/layout": [149,[5]],
		"/showcase/components/market": [150,[5]],
		"/showcase/components/navigation": [151,[5]],
		"/showcase/design-system": [152,[5]],
		"/showcase/examples": [153,[5]],
		"/showcase/examples/checkout-flow": [154,[5]],
		"/showcase/layouts": [155,[5]],
		"/signin": [~156],
		"/users/list": [~163],
		"/user/change-password": [~157],
		"/user/edit": [~158],
		"/user/history/adjustments": [~159],
		"/user/history/orders": [~160],
		"/user/signin": [~161],
		"/user/stripe-card": [~162],
		"/weblog": [~164],
		"/weblog/view/[id]": [~166],
		"/weblog/[id]": [~165],
		"/welcome": [~167]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';